// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from "react";

const SvgArrowRight12 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 12 12"
		{...props}
	>
		<path
			fill="currentColor"
			d="M1.8 6.795h6.068L6.034 8.626a.799.799 0 1 0 1.131 1.13l3.2-3.195a.798.798 0 0 0 0-1.132l-3.2-3.195a.8.8 0 0 0-1.13 1.131l1.833 1.832H1.8a.8.8 0 0 0-.566 1.364.8.8 0 0 0 .566.234Z"
		/>
	</svg>
);
export default SvgArrowRight12;
